import { HighlightStyle } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';

export default HighlightStyle.define([
  { tag: t.heading1, fontWeight: 'bold', fontSize: '1.6em', textDecoration: 'none' },
  { tag: t.heading2, fontWeight: 'bold', fontSize: '1.4em', textDecoration: 'none' },
  { tag: t.heading3, fontWeight: 'bold', fontSize: '1.2em', textDecoration: 'none' },
  { tag: t.heading, fontWeight: 'bold' }
]);